import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { LoadingWrapper } from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { localStorageHelper } from '~/accounts/core/utils';
import track, { analyticsTypes } from '~/app/vet/core/analytics';
import UserInfo from '../forms/UserInfo';
import { CLINIC_FORM_URL } from '../constants';

const classNamePrefix = 'Signup--FormPage';
const localStorageSaveLocation = '_saved_profile_form';

class UserProfileView extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'handleSubmit');

    this.state = {
      profile: localStorageHelper.retreiveJson(localStorageSaveLocation)
    };
  }

  componentDidMount() {
    track(analyticsTypes.SIGNUP_VIEW, _.get(this.props, 'location.query', {}));
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { profileFetches: prevProfileFetches } = prevProps;
    const {
      profileFetches,
      profileFetchAction,
      profile,
      router,
      location
    } = this.props;

    if (!profileFetches.isError && prevProfileFetches.isCreating === true && profileFetches.isCreating === false) {
      if (_.isEmpty(profile)) {
        // If the profile is empty, that currently means that we were logged via the create request
        // let's fetch the profile
        profileFetchAction();
      } else {
        // Move to the clinic signup page because we have created the profile
        router.push({
          pathname: CLINIC_FORM_URL,
          search: location.search
        });
      }
    }
  }

  handleSubmit(values) {
    const { query } = this.props.location;
    this.props.profileCreateAction({...values, query});
  }

  render() {
    const {
      profileFetches
    } = this.props;
    const { profile } = this.state;

    return (
      <LoadingWrapper loading={profileFetches.isLoading}>
        <Row align='middle' justify='center' className={classNamePrefix}>
          <Col className={`${classNamePrefix}__title`} span={12}>
            <h2>Let&apos;s create your veterinary practice&apos;s purchasing account!</h2>
            <h4>Signing up for Vetcove is fast and free - you&apos;ll be up and running in under a minute</h4>
          </Col>
          <Col span={12}>
            <UserInfo
              onChange={values => localStorageHelper.saveJson(localStorageSaveLocation, _.omit(values, ['password', 'promo_code']))}
              initialValues={{
                ...profile,
                isDisabledAsyncValidate: false,
              }}
              disabled={profileFetches.isLoading}
              onSubmit={this.handleSubmit}
            />
          </Col>
        </Row>
      </LoadingWrapper>
    );
  }
}

UserProfileView.propTypes = {
  profileCreateAction: PropTypes.func.isRequired,
  profileFetchAction: PropTypes.func.isRequired,
  profileFetches: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default UserProfileView;
